// firebase/index
export const firebaseConfig = {
	apiKey: "AIzaSyAkt4zIRzbeEn-AIvRgr1We2lq4hvi3rck",
	authDomain: "agriexpo-organico-latam.firebaseapp.com",
	projectId: "agriexpo-organico-latam",
	storageBucket: "agriexpo-organico-latam.appspot.com",
	messagingSenderId: "198246625145",
	appId: "1:198246625145:web:201aa40cb290b3492c09a8",
	measurementId: "G-8E2QSSRB4W"
}

// firebase/storage
export const storageUrl = 'https://firebasestorage.googleapis.com/v0/b/agriexpo-organico-latam.appspot.com/o/'